<template>
  <v-layout wrap>
    <v-flex sm12>
      <v-card id="editorjs"></v-card>
    </v-flex>
    <v-flex sm12 class="text-center" mt-8>
      <v-btn @click="save" class="primary">Guardar</v-btn>
    </v-flex>

    <v-snackbar v-model="snackbar" right top :timeout="3000">
      {{ message }}
      <v-btn color="blue" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import List from "@editorjs/list";
import axios from "axios";
export default {
  data() {
    return {
      editor: null,
      snackbar: false,
      message: "",
      create: false,
      idSetting: "",
      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    save() {
      this.editor
        .save()
        .then(outputData => {
          if (this.create) {
            //crea documento
            let data = {
              type: "help_client",
              content: JSON.stringify(outputData),
              idUserVerify: sessionStorage.getItem("authorization")
            };

            axios
              .post(
                this.host + "/settings/create.php",
                this.createFormData(data)
              )
              .then(response => {
                this.message = response.data.message;
                this.snackbar = true;
                this.create = false;
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            //actualiza documento

            let data = {
              idSetting: this.idSetting,
              content: JSON.stringify(outputData),
              idUserVerify: sessionStorage.getItem("authorization")
            };

            axios
              .post(
                this.host + "/settings/update.php",
                this.createFormData(data)
              )
              .then(response => {
                this.message = response.data.message;
                this.snackbar = true;
                this.create = false;
              })
              .catch(error => {
                console.log(error);
              });
          }
        })
        .catch(error => {
          console.log("Saving failed: ", error);
        });
    },
    init() {
      let data = {
        type: "help_client"
      };

      axios
        .post(this.host + "/settings/read.php", this.createFormData(data))
        .then(response => {
          let data = {};
          this.create = true;
          if (response.data.status) {
            this.create = false;
            data = JSON.parse(response.data.data.content);
            this.idSetting = response.data.data.idSetting;
          }

          this.editor = new EditorJS({
            autofocus: true,
            placeholder: "Escribe...",
            tools: {
              header: {
                class: Header,
                inlineToolbar: ["link"]
              },
              list: {
                class: List,
                inlineToolbar: ["link", "bold"]
              }
            },
            data
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  },
  mounted() {
    this.init();
  }
};
</script>